import React, { useEffect, useState } from 'react';
import { eventsAPI, unwrapList } from '../../services/api';
import DeskStation from './DeskStation';

const GiftStation = () => {
  const [batches, setBatches] = useState([]);
  const [batchId, setBatchId] = useState('');

  useEffect(() => {
    eventsAPI.giftBatches().then((response) => {
      const rows = unwrapList(response.data).filter((batch) => batch.is_active);
      setBatches(rows);
      if (rows[0]) setBatchId(String(rows[0].id));
    });
  }, []);

  return (
    <DeskStation
      title="禮品櫃台"
      hint="掃描器請使用鍵盤模式。掃入此欄後按 Enter 即領取禮品。"
      selected={batchId}
      onSelect={setBatchId}
      options={batches.map((batch) => (
        <option key={batch.id} value={batch.id}>{batch.name}</option>
      ))}
      onScan={async (q) => {
        const response = await eventsAPI.redeem({ q, gift_batch_id: batchId });
        return response.data;
      }}
    />
  );
};

export default GiftStation;
